import { lazy } from "react";

const RELOAD_FLAG = "chunk-load-reload";

// After a deploy, an open tab still references the old chunk hashes, which no longer exist.
// Reload once to pick up the new index.html; if it still fails, let the error boundary handle it.
const lazyWithReload = importPage =>
  lazy(() =>
    importPage().then(
      module => {
        sessionStorage.removeItem(RELOAD_FLAG);
        return module;
      },
      error => {
        if (sessionStorage.getItem(RELOAD_FLAG)) {
          throw error;
        }
        sessionStorage.setItem(RELOAD_FLAG, "true");
        window.location.reload();
        return new Promise(() => {});
      }
    )
  );

export default lazyWithReload;
